const _ = require('lodash');
const { SYSTEM_PARAM_PREFIX } = require('../misc/sharedConstants');
const COUNTRIES = require('../reportData/countries');
const GranularDimension = require('./granularDimension');

const toSysHbDim = (name) => `_${SYSTEM_PARAM_PREFIX}${name}`;

/** Default dimensions that are always used. */
const DefaultGranularDims = [
	{
		hbDim: 'floorRange',
		unitName: 'floorIdx',
		desc: 'Floor Range',
		approxNumValues: 50,
		group: 0,
	},
	{
		hbDim: toSysHbDim('Browser name'),
		unitName: 'browser',
		checkStringIncluded: true,
		values: [
			'Chrome',
			'Safari',
			'Microsoft Edge',
			'Firefox',
		],
		desc: 'Browser',
		group: 0,
	},
	{
		hbDim: 'country',
		unitName: 'country',
		desc: 'Country',
		approxNumValues: 50,
		convertToValidUnitValue: (code) => {
			const s = COUNTRIES[code];
			return s ? ((code.charCodeAt(1) * 256) + code.charCodeAt(0)) : null;
		},
		group: 1,
	},
].map((d) => new GranularDimension(d));

const BuiltInCustom = [
	// TODO: uncomment below when optimization is ready..
	// {
	// 	hbDim: toSysHbDim('Optimization'),
	// 	values: ['Enabled'],
	// 	group: 0,
	// },
	// {
	// 	hbDim: toSysHbDim('Optimization group'),
	// 	values: ['Test'],
	// 	group: 0,
	// },
	{
		hbDim: toSysHbDim('Reloading'),
		values: ['Yes'],
		group: 1,
	},
];

module.exports = {
	DefaultGranularDims,
	BuiltInCustom,
};
